import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './styles.module.scss';

const propTypes = {
  children: PropTypes.node.isRequired,
  byLine: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  byLineName: PropTypes.string,
  byLineTitle: PropTypes.string,
  label: PropTypes.string,
  companyLogo: PropTypes.node,
  variant: PropTypes.oneOf(['card'])
};

const Testimonial = ({children, byLine, byLineName, byLineTitle, label, companyLogo, variant}) => (
  <figure className={cx(styles.testimonial, {[styles['testimonial--card']]: variant === 'card'})}>
    {(companyLogo || label) && (
      <div className={styles.testimonial__header}>
        {companyLogo && <div className={styles.testimonial__company}>{companyLogo}</div>}
        {label && <span className={`heading-5 ${styles.testimonial__label}`}>{label}</span>}
      </div>
    )}
    <blockquote className={styles.testimonial__content}>{children}</blockquote>
    {(byLineName || byLine) && (
      <figcaption className={styles.testimonial__byline}>
        <span className={styles.testimonial__byline_text}>
          {byLineName && <span className={styles.testimonial__byline_name}>{byLineName}</span>}
          {byLineTitle && <span className={styles.testimonial__byline_title}>{byLineTitle}</span>}
          {!byLineName && byLine}
        </span>
      </figcaption>
    )}
  </figure>
);

Testimonial.propTypes = propTypes;

export default Testimonial;
